<template>
  <div :class="formGroupClass">
    <div class="input-group input-group-sm mb-3">
      <slot name="before"/>
      <label for="form-subject-type" class="control-label">{{ inputLabel }}</label>
      <div style="display: flex">
        <b-dropdown
            :id="'organization-subject-input'"
            toggle-class="right-border-radius-unset right-border-none subject-input-dropdown"
            :disabled="disabled"
            ref="dropdown"
            class="subject-input-residency-list"
        >
          <template #button-content>
            <img
                v-if="selectedNationality"
                class="flag_img subject-input-flag"
                :src="selectedNationalityImage"
                :alt="selectedNationality.iso2"
            />
            <slot name="arrow-icon" :open="open">
              <span class="vti__dropdown-arrow subject-input-arrow" v-if="isView === false">{{ open ? "▲" : "▼" }}</span>
            </slot>
          </template>
          <template v-for="(nationality, key) in nationalities">
            <b-dropdown-item
                :key="key"
                :style="{cursor: 'pointer'}"
                @click="changeNationality(nationality)"
            >
              <img class="flag_img" :src="iconsPath + nationality.iso2 + '.svg'" alt="" width="20" />
              <span style="margin-left: 5px"
              ><strong>{{ nationality.full_name }}</strong></span
              >
            </b-dropdown-item>
          </template>
          <slot name="lastItems"></slot>
        </b-dropdown>
        <select
            id="form-subject-type"
            class="form-control subject-input-select"
            v-model="inputValue"
            @change="emit($event)"
            @input="emit($event)"
            :disabled="disabled"
        >
          <option
              v-for="subject in nationalitySubjects"
              v-bind:key="subject.id"
              :value="subject.id"
          >{{ subject.name }}
          </option>
        </select>
      </div>
      <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
      <slot name="after"/>
    </div>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'

export default {
  name: 'OrganizationSubjectInput',
  data: () => ({
    open: false
  }),

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Субъект права'
    },

    inputName: {
      default: 'subject_id'
    },

    items: {
      type: [Array],
      default: () => []
    },

    disabled: {
      default: false,
      type: Boolean
    },

    nationalitiesList: {
      default: []
    },

    organizationSubjectsResidency: {
      default: []
    },

    modelValue: String
  },

  computed: {
    selectedNationalityImage() {
      return this.iconsPath + this.selectedNationality.iso2 + '.svg'
    },

    iconsPath() {
      return process.env.BASE_URL + 'img/icons/countries/'
    },

    nationalities() {
      const nationalitiesId = [
        ...new Set(this.organizationSubjectsResidency.map((value) => Number(value.nationality_id)))
      ]

      return this.nationalitiesList.filter((nationality) =>
        nationalitiesId.includes(nationality.id)
      )
    },

    nationalitySubjects() {
      const subjectsId = [
        ...new Set(
          this.organizationSubjectsResidency
            .filter((value) => Number(value.nationality_id) === this.selectedNationality.id)
            ?.map((value) => value.subject_id)
        )
      ]

      return this.items.filter((subject) => subjectsId.includes(subject.id))
    },

    nationalitySubjectsId() {
      return this.nationalitySubjects.map((x) => x.id)
    },

    selectedNationality() {
      return this.nationalities.find((n) => n.id === this.form.organization.nationality_id) ??
        this.nationalities.find((n) => n.iso2 === 'RU')
    }
  },

  methods: {
    changeNationality(nationality) {
      this.cleanFormOrganizationData()
      this.form.organization.nationality_id = nationality.id

      this.selectedNationality = nationality
    },

    cleanFormOrganizationData() {
      this.$parent.$data.prevManagerName = null
      this.$parent.$data.prevAddress = null;
      this.$parent.$data.prevManagerPosition = null
      this.form.prevManagerName = null
      this.form.organization.inn = null
      this.form.organization.name = ''
      this.form.organization.address = ''
      this.form.organization.director_name = ''
      this.form.organization.phone = ''
      this.form.organization.position_of_manager = ''
    }
  },

  watch: {
    selectedNationality() {
      if (this.nationalitySubjectsId.includes(this.inputValue) === false) {
        this.inputValue = this.nationalitySubjectsId[0]
      }
    }
  }
}
</script>
